import React from "react";
import ReactDOM from "react-dom";
import { Provider } from "react-redux";

// import registerServiceWorker from "./registerServiceWorker";
import configureStore from "./redux/store/";
import App from "./containers/app/App";
// import {CheckUserLoginFromApi} from "./redux/utils/authUtils";

// style
// import "bootstrap/dist/css/bootstrap.css";
// import "font-awesome/css/font-awesome.css";
import jquery from "jquery";
import './assets/vendors/base/fonts/vazir/vazir.css';
// import './assets/vendors/base/vendors.bundle.css';
import './assets/vendors/base/fonts/flaticon/Flaticon.css';
import './assets/vendors/base/fonts/line-awesome/line-awesome.css';
import './assets/vendors/base/fonts/font-awesome/css/font-awesome.min.css';

import './assets/vendors/base/mdb/css/mdb.css';
import './assets/vendors/base/bootstrap-rtl.min.css';
import './assets/themes/front/base/style.bundle.css';
import './../node_modules/react-toastify/dist/ReactToastify.min.css';
import './../node_modules/react-image-lightbox/style.css';
import './assets/custom/front/style.bundle.css';

window.$ = window.jQuery = jquery;
window.Popper = require("popper.js");
require("bootstrap/dist/js/bootstrap");



const store = configureStore();
// CheckUserLoginFromApi(store);

ReactDOM.render(
  <Provider store={store}>
    <App store={store}/>
  </Provider>,
  document.getElementById("root")
);

// registerServiceWorker();



// WEBPACK FOOTER //
// ./src/index.js